module.exports = __webpack_public_path__ + "assets/img/enterpeise-service.7ff991f0.jpg";